import React from "react";
import { IconWrapperRounded } from "../../../components/IconWrapperRounded";
import { colors } from "../../../components/colors";
import { StyledText } from "../../../assets/typography/typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
  header: string;
  subtitle?: string;
}

export const SmallWidgetBase = ({ icon, header, subtitle, ...rest }: Props) => {
  return (
    <>
      <div
        className="d-flex flex-row align-items-center h-100"
        style={{ gap: "16px" }}
        {...rest}
      >
        {icon && (
          <IconWrapperRounded
            backgroundColor={colors.ctaMain}
            color={colors.white}
          >
            {icon}
          </IconWrapperRounded>
        )}
        <div
          className="d-flex flex-column justify-content-start"
          style={{ gap: "4px" }}
        >
          <StyledText
            color={colors.textPrimary}
            className="bodyTextSemibold mb-0"
          >
            {header}
          </StyledText>
          {subtitle && (
            <StyledText
              color={colors.textSecondary}
              className="bodySubtextRegular mb-0"
            >
              {subtitle}
            </StyledText>
          )}
        </div>
      </div>
      <StyledText
        color={colors.textPrimary}
        className="bodySubtextRegular mb-0"
      >
        <FontAwesomeIcon icon={solid("arrow-right")} />
      </StyledText>
    </>
  );
};
